import './SettingsAvatar.scss'
import './SettingsSelect.scss'

import React, {Component} from 'react'
import { Image } from 'react-bootstrap'
import SettingsSelect from './SettingsSelect.js'

import {
  updateAvatar, createSocialProfile, updateSocialProfiles
} from 'manager/redux/settings'

const SettingsAvatar = ({dispatch, settings, onSelect}) => {

  let options = [
    {label:'None', value:null}
  ]

  let facebookProfile = null
  if (settings.social_profiles) {
    for (let profile of settings.social_profiles) {
      if (profile.platform === 'facebook') {
        facebookProfile = profile
      }
      options.push({label:profile.name, value:profile.image_path})
    }
  }

  let additionalMap = {}
  if (facebookProfile) {
    additionalMap[facebookProfile.image_path] = <Image src={facebookProfile.image_path} className="SettingsSelect__user-image"/>
  }

  function responseFacebook(response) {
    let profiles = []
    if (settings.social_profiles) {
      profiles = profiles.concat(settings.social_profiles)
    }
    let imagePath = 'https://graph.facebook.com/' + response.userID + '/picture?type=large'
    profiles.push({
      platform: 'facebook',
      name: response['name'],
      image_path: imagePath,
    })
    dispatch(updateSocialProfiles(profiles))
    dispatch(createSocialProfile())
    onSelect(imagePath)
  }

  return (
    <div className="SettingsAvatar">
      <div className="Settings__label">My Profile Avatar</div>
      <SettingsSelect options={options} selected={settings.image_path ? settings.image_path : null} leftAdditionalMap={additionalMap} onClick={onSelect} />
    </div>
  )
}

export default SettingsAvatar
